export function getTheFirstElementOfArray(array) {
  if (!array) return '';
  const [firstElement] = array;
  return firstElement;
}

export function getTheLastElementOfArray(array) {
  const lastElement = array[array.length - 1];
  return lastElement;
}

export function isArrayEmpty(array = []) {
  // if value is not an array or array length is 0, return true
  return !Array.isArray(array) || array.length === 0;
}
